module.exports = __webpack_public_path__ + "static/media/samplefile_user.32eb90c2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/sample/samplefile_user.csv
// module id = 1403
// module chunks = 1